import { apiRequests } from "../services/api";
import { GET_ALL_ACTIVITY } from "../graphql/query/activity/query";
import { CREATE_ACTIVITY , UPDATE_ACTIVITY , DELETE_ACTIVITY} from "../graphql/mutations/activity/mutations";

//QUERY
export const getActivityAll = async() => {
    try {
        const response = await apiRequests(GET_ALL_ACTIVITY);
        //console.log('abc' , response);
        if(response != null ){
            return response.data.getActivity;
        }else{
            return null;
        }
    } catch ( err ) {
        console.warn('Errores de fronted' , err)
    }
} 

//MUTATIONS
export const createActivityNew = async(variables)=>{
    try {
        const response = await apiRequests(CREATE_ACTIVITY , { requestActivite: variables } );
        if (response?.data?.createActivity?.activity) {
            return response.data.createActivity.activity;
        }else {
            console.warn('Error en la creación:', response?.data?.createActivity?.message);
            return null;
        }
    }catch( err ){
        console.warn('Errores en el fronted ' , err);
    }
}

export const updateActivity = async(variables)=>{
    try {
        const response = await apiRequests(UPDATE_ACTIVITY , { requestActivite: variables } );
        if (response?.data?.updateActivity?.activity) {
            return response.data.updateActivity.activity;
        }else {
            console.warn('Error en la actualizacion:', response?.data?.updateActivity?.message);
            return null;
        }
    }catch( err ){
        console.warn('Errores en el fronted ' , err);
    }
}

export const deleteActivity = async(id)=>{
    try {
        //console.log('234567',id);
        const variables = {
            id: id
        };
        const response = await apiRequests(DELETE_ACTIVITY , variables );
        //console.log('response', response);
        if (response.data.deleteActivity?.activity ) {
            return response.data.deleteActivity;
        }else {
            console.warn('Error en la creación:', response?.data?.deleteActivity?.message);
            return response.data.deleteActivity;
        }
    }catch( err ){
        console.warn('Errores en el fronted ' , err);
    }
}